import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "creteNewRRequest" }
const _hoisted_2 = { class: "formContent" }
const _hoisted_3 = { class: "overflowDiv" }
const _hoisted_4 = { class: "footersec" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Cancel")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_form, {
        ref: "priceFormRef",
        model: _ctx.priceModal,
        rules: _ctx.priceRules,
        "label-col": _ctx.labelCol,
        "wrapper-col": _ctx.wrapperCol,
        colon: false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_form_item, {
              label: "Credit Count till",
              required: "",
              name: "credits_till"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.priceModal.credits_till,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.priceModal.credits_till) = $event)),
                  type: "number",
                  placeholder: "",
                  "allow-clear": "",
                  autocomplete: "off"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "Price per unit",
              required: "",
              name: "price_per_unit"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.priceModal.price_per_unit,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.priceModal.price_per_unit) = $event)),
                  type: "number",
                  placeholder: "",
                  "allow-clear": "",
                  autocomplete: "off"
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_a_button, {
              class: "cancel",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cancelPricerequest()))
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, {
              class: "add",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sendRequest())),
              loading: _ctx.confirmLoading
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.saveText), 1)
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ]),
        _: 1
      }, 8, ["model", "rules", "label-col", "wrapper-col"])
    ])
  ]))
}